import React, { useEffect, useState } from 'react';
import { FlatList, View } from "react-native"
import { useDispatch, useSelector } from 'react-redux';
import ActionModal from '../../../Componentsv1/ActionModal';
import OrderGradeBar from '../../../Componentsv1/OrderGradeBar';
import Colors from "../../../constants/Colorsv2"
import { Text, TouchableOpacity } from "../../../globalComponents/NativeOverrides"
import { market_cancelOrder, market_getOrderSuggestions, market_modifyOrder } from '../../../store/actionsv1/markets';
import { PublicPlayerProps } from '../../../store/types/auth_svc';
import { MarketProps, OrderProps } from "../../../store/types/mk_svc"
import { market_getOddsLabel } from '../helpers/markets';
import { order_calcAmericanOddsFromProbability } from '../helpers/orders';
import OrderModificationModal from './OrderModificationModal';
import { Icon } from 'react-native-elements';
import { player_getHelpPromptById } from '../../../store/actionsv1/player';


type OrderBookCardProps = {
    orders: OrderProps[],
    market: MarketProps,
    onBuy: (order:OrderProps) => void
}
const init_options = [
    { value: 'cancel', label: 'Cancel Order', color: Colors.utility.error }
]
const OrderBookCard = ({ orders, market, onBuy }:OrderBookCardProps) => {
    const [ action_visible, setActionVisible ] = useState(false)
    const [ modify_order_state, setModifyOrderstate ] = useState({
        order_id: undefined,
        modifying_property: undefined,
        new_value: undefined,
        confirm_visible: false
    })
    const [ options, setOptions ] = useState(init_options)
    const { order_id, modifying_property, new_value, confirm_visible } = modify_order_state;
    
    const dispatch = useDispatch();
    const trade_side_orders = orders.filter(o => o.side === market.trade_side).sort((a,b) => a.probability - b.probability).splice(0, 9)
    const o_side_orders = orders.filter(o => o.side !== market.trade_side).sort((a,b) => a.probability - b.probability).splice(0,9)
    let premium = false
    const player:PublicPlayerProps|undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const player_premium_item = useSelector((state:any) => state.player.player_premium_items_list.player_premium_items.find(ppi => ppi.premium_item?.identifier == 'advanced_market_analytics'), (left, right) => left?.last_update_datetime == right?.last_update_datetime);
    if(player?.type == 'premium' || player_premium_item){ premium = true }
    const orders_state:{ updated:number, orders:OrderProps[] } = useSelector((state:any) => state.player.orders, (left, right) => {
        if(left.updated !== right.updated){ return false }
        return true
    })
    const modifying_order = orders_state.orders.find(o => o.order_id == order_id)
    useEffect(() => {
        if(!modifying_order){ return }
        let new_options = []
        if(modifying_order?.jump_queue_probability){
            new_options.push({ value: 'jump_queue', label: `Jump Queue: ${(modifying_order.jump_queue_probability*100).toFixed(2)}% (${market_getOddsLabel(order_calcAmericanOddsFromProbability(modifying_order.jump_queue_probability))})`, color:Colors.brand.midnight })
        }
        if(modifying_order?.buy_now_probability){
            new_options.push({ value: 'buy_now', label: `Buy Now: ${(modifying_order.buy_now_probability*100).toFixed(2)}% (${market_getOddsLabel(order_calcAmericanOddsFromProbability(modifying_order.buy_now_probability))})`, color:Colors.brand.midnight })
        }
        new_options = new_options.concat(init_options)
        setOptions(new_options)
    },[modifying_order?.jump_queue_probability, modifying_order?.buy_now_probability])

    const handleModifyOrder = () => {
        setModifyOrderstate({ ...modify_order_state, confirm_visible: false })
        if(!modifying_order || !new_value || modifying_order?.player_id != player?.player_id){ return }
        dispatch(market_modifyOrder(modifying_order.order_id, 'probability', new_value))
    }

    const handleOrderPress = async(order:OrderProps) => {
        if(!onBuy || !player){ return }
        if(player?.player_id == order.player_id){
            await setModifyOrderstate({ ...modify_order_state, order_id: order.order_id })
            await dispatch(market_getOrderSuggestions(order.order_id))
            return await setActionVisible(true)
        }
        if(!premium){
            return dispatch(player_getHelpPromptById('t2_analytics_2'))
        }
        return onBuy(order)
    }

    const handleOptionSelect = async(option:any) => {
        if(!order_id){ return }
        setActionVisible(false)
        switch(option.value){
            case 'cancel':
                return await dispatch(market_cancelOrder(order_id))
            case 'jump_queue':
                if(!modifying_order?.jump_queue_probability){ return }
                if(!premium){ return alert('Must be a premium user to use this functionality') }
                return setModifyOrderstate({
                    ...modify_order_state,
                    confirm_visible: true,
                    modifying_property: 'probability',
                    new_value: modifying_order?.jump_queue_probability
                })
            case 'buy_now':
                if(!modifying_order?.buy_now_probability){ return }
                return setModifyOrderstate({
                    ...modify_order_state,
                    confirm_visible: true,
                    modifying_property: 'probability',
                    new_value: modifying_order?.buy_now_probability
                })
            default: return
        }
    }

    const renderTradeSide = (data: {item: OrderProps, index:number}) => {
        const cl = data.item.market_type === 'FOR_MONEY' ? '$' : 'E'
        const mine = data.item.player_id == player?.player_id ? true : false
        return (
            <TouchableOpacity style={{ minHeight:40, backgroundColor:premium||mine?Colors.shades.shade600:Colors.shades.black_faded, margin:4, marginLeft:8, borderRadius:4 }} onPress={() => handleOrderPress(data.item)}>
                {premium || mine ?
                <View style={{ flex:1, flexDirection:'row', alignItems:'center' }}>
                    <OrderGradeBar grade={data.item.grade} view_type='book' />
                    <Text size={12} color={Colors.shades.black} weight='semibold' textAlign='center' style={{flex:1/2}}>{market_getOddsLabel(data.item.odds)}</Text>
                    <Text size={12} color={Colors.shades.black} weight='semibold' textAlign='center' style={{flex:1/2}}>{cl}{data.item.open_amt.toFixed(2)}</Text>
                </View>
                :
                <View style={{ flex:1, justifyContent:'center', alignItems:'center' }}>
                    <Icon color={Colors.incentive.gold} name='lock' type='feather' style={{ alignSelf: 'center' }} size={14}/>
                </View>
                }
                {mine ?
                <View style={{ position:'absolute', right:0, bottom:0, top:0, width:5, backgroundColor:Colors.brand.electric, borderRadius:4 }} />
                :<></>}
            </TouchableOpacity>
        )
    }
    const renderOSide = (data: {item: OrderProps, index:number}) => {
        const cl = data.item.market_type === 'FOR_MONEY' ? '$' : 'E'
        const mine = data.item.player_id == player?.player_id ? true : false
        return (
            <TouchableOpacity style={{ minHeight:40, backgroundColor:premium||mine?Colors.shades.shade600:Colors.shades.black_faded, margin:4, marginLeft:8, borderRadius:4 }} onPress={() => handleOrderPress(data.item)}>
                {premium || mine ?
                <View style={{ flex:1, flexDirection:'row', alignItems:'center' }}>
                    <Text size={12} color={Colors.shades.black} weight='semibold' textAlign='center' style={{flex:1}}>{cl}{data.item.open_amt.toFixed(2)}</Text>
                    <Text size={12} color={Colors.shades.black} weight='semibold' textAlign='center' style={{flex:1}}>{market_getOddsLabel(data.item.odds)}</Text>
                    <OrderGradeBar grade={data.item.grade} view_type='book' />
                </View>
                :
                <View style={{ flex:1, justifyContent:'center', alignItems:'center' }}>
                    <Icon color={Colors.incentive.gold} name='lock' type='feather' style={{ alignSelf: 'center' }} size={14}/>
                </View>
                }
                {mine ?
                <View style={{ position:'absolute', left:0, bottom:0, top:0, width:5, backgroundColor:Colors.brand.electric, borderRadius:4 }} />
                :<></>}
            </TouchableOpacity>
        )
    }

    return (
        <View>
            <View style={{ flex:1, flexDirection:'row' }}>
                <View nativeID="other_side_orders" style={{ flex:1 }}>
                    <FlatList data={o_side_orders} renderItem={renderOSide} keyExtractor={(item) => item.order_id.toString()}/>
                </View>
                <View nativeID="trade_side_orders" style={{ flex:1 }}>
                    <FlatList data={trade_side_orders} renderItem={renderTradeSide} keyExtractor={(item) => item.order_id.toString()}/>
                </View>
            </View>
            <View nativeID='legend' style={{ flexDirection:'row', alignItems:'center', justifyContent:'center', padding:10 }}>
                <View style={{ height:10, width:10, borderRadius:4, marginRight:5, backgroundColor:Colors.brand.electric }} />
                <Text size={12} color={Colors.shades.black} weight='regular'>Your order</Text>
            </View>
            <ActionModal 
                isVisible={action_visible} 
                closeModal={() => setActionVisible(false)} 
                options={options} 
                label_attribute='label'
                onSelectOption={(option) => handleOptionSelect(option)}/>
            <OrderModificationModal 
                isVisible={confirm_visible}
                order={modifying_order}
                modifying_property={modifying_property}
                new_value={new_value}
                closeModal={() => setModifyOrderstate({ ...modify_order_state, confirm_visible:false })}
                onConfirm={() => handleModifyOrder()}

            />
        </View>
        
    )
}

export default OrderBookCard